











import Vue from 'vue'
import msgrsList from '@/components/Users/Page/msgrsList.vue'
import User from '@/models/Users/User'

export default Vue.extend({
  name: 'stuffColMsgrList',
  props: {
    row: Object as () => User,
  },
  components: {
    msgrsList
  }
})
